import { useState } from 'react';
import Dashboard from './pages/Dashboard';
import Tenants from './pages/Tenants';
import Orders from './pages/Orders';
import Settings from './pages/Settings';
import Alerts from './pages/Alerts';

function App() {
  const [activeTab, setActiveTab] = useState<'dashboard' | 'tenants' | 'orders' | 'alerts' | 'settings'>('tenants');
  const [selectedTenantId, setSelectedTenantId] = useState<string | null>(null);

  const tabs = [
    { id: 'tenants' as const, label: 'Tenants', icon: '🏢' },
    { id: 'dashboard' as const, label: 'Dashboard', icon: '📊' },
    { id: 'orders' as const, label: 'Orders', icon: '📦' },
    { id: 'alerts' as const, label: 'Alerts', icon: '🚨' },
    { id: 'settings' as const, label: 'Settings', icon: '⚙️' },
  ];

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Pay Hub Admin</h1>
              <p className="text-sm text-gray-600">Dashboard manajemen platform pembayaran multi-tenant</p>
            </div>
            <div className="flex items-center gap-4">
              <div className="text-sm text-gray-600">
                <span className="font-medium">Admin</span>
              </div>
              <button className="bg-gray-200 text-gray-700 rounded-lg px-4 py-2 hover:bg-gray-300">
                Logout
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Navigation Tabs */}
      <div className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4">
          <nav className="flex space-x-1">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
                  activeTab === tab.id
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300'
                }`}
              >
                <span className="mr-2">{tab.icon}</span>
                {tab.label}
              </button>
            ))}
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 py-6">
        {activeTab === 'tenants' && (
          <Tenants
            selectedTenantId={selectedTenantId}
            onSelectTenant={setSelectedTenantId}
          />
        )}
        
        {activeTab === 'dashboard' && (
          <Dashboard selectedTenantId={selectedTenantId} />
        )}
        
        {activeTab === 'orders' && (
          <Orders selectedTenantId={selectedTenantId} />
        )}

        {activeTab === 'alerts' && (
          <Alerts selectedTenantId={selectedTenantId} />
        )}
        
        {activeTab === 'settings' && (
          <Settings />
        )}
      </main>

      {/* Footer */}
      <footer className="bg-white border-t mt-auto">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="text-center text-sm text-gray-600">
            © 2025 Pay Hub. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
